module.exports = {
 'fitness':'Digital Fitness for the Future',
 'shop':'SHOP PACKAGE',
 'speediance':'SPEEDIANCE',
 'video':'Watch the video to learn all about Speediance’s features',
 'noSupport':'Your browser does not support video tags.',
 'workout':'Start your workout with Speediance',
 'workouts':'Workouts',
 'courses':'We offer a wide variety of courses to meet all your fitness needs,from strength training and stretching to aerobic exercises and body building',
 'movement':'Movement',
 'more':'Speediance features more than',
 'moves':'moves that are fun and effective to get the most out of your workouts',
 'onlineCourses':'Online courses',
 'coaches':'We also have online courses which will be live streamed at a fixed time and invite professional fitness coaches to share fitness skills and health knowledge',
 'accessories':'Various Accessories',
 'links':'We offer various accessories and accessory switch links that can bring rich, varied moves and different use experiences',
 'powerful':'So Powerful',
 'core':'The Core of SPEEDIANCE',
 'motors':'High-performance Motors',
//  'maximum':'Each motor provides a maximum weight of 110lbs and two motors provide 220lbs',
'maximum':'Each motor provides a maximum weight of',
'110lbs':'110lbs',
'220lbs':'220lbs',
'provide':'and two motors provide',
 'algorithms':'Intelligent Algorithms',
 'accurate':'Weight regulation can be accurate to',
 '1lbs':'1lbs',
 'vision':'Broad Vision',
 'screen':' Speediance provides a super large screen,so that you feel like your coach is right in front of you when you exercise; meanwhile,the high-quality screen and sound bring perfect audio-visual effects',
 'size':'Screen Size',
 'second':'The weight can be adjusted in one second on the screen',
 'handle':'Smart Handle',
 'controller':'Barbell Bar Controller',
 'reduce':'Reduce distractions during workouts Quick weight adjustment Make workouts safer',
 'button':'There is a control button at each end of the handle;press the button to turn the weight on or off and control the weight in your hands',
 'barbell':'The barbell controller can be clamped to the barbell and can turn the weight on or off and adjust the weight,so that you can easily use the barbell without assistance from others',
 'sFitness':'Smart fitness',
 'dynamic':'Speediance has a powerful intelligent algorithm which takes fitness away from boring numbers and weights;dynamic weights will bring a revolutionary experience; the weight changes along with your heartbeat, and posture correction is available',
 'recognition':'Posture recognition',
 'beginner':'How do you make sure your moves are correct when you are exercising alone? This is the bane of every beginner',
 'identify':'Speediance uses sensors to automatically identify the range and frequency of your moves,the way you wear accessories and other factors, determine whether your moves are standard, and give advice',
 'weight':'Dynamic weight',
 'modes':'Four smart training modes',
 'efficient':'Speediance dynamically adjust weight during your workout, stimulating your muscles and making your workout more efficient',
 'spotter':'Spotter mode',
 'exhaustion':'During workouts, exhaustion can lead to non-standard moves and even danger.When Speediance automatically detects exhaustion,it reduces the weight to help stabilize the user’s moves',
 'users':'Speediance users will experience meticulous services,schedule their workouts, exercise freely and track workout results',
 'app':'SPEEDIANCE has a great workout app',
 'phone':'You can manage your workouts on your phone',
 'records':' You can view all your workout records, reports, courses, etc. on the machine on your phone. Everything can be found under the same account',
 'profile':'Slender profile',
 'craft':'Exquisite craft',
 'necessary':'No installment necessary',
 'easily':'Easily folded for storage',
 'covers':'It covers',
 'meters':'0.3 square meters',
 'chair':'Equivalent to the floor space of a chair',
 'make':'Make Speediance a ',
 'life':'part of your life ',
 'motor':'The noise-reduced motor allows the machine to operate without disturbing others; with a simple design,it can be perfectly integrated into the home environment',
 'coming':'SPEEDIANCE is coming',
 'price':'Bring SPEEDIANCE home now at the best price',
 'rope':'Tricep Rope',
 'bench':'Flat Bench',
 'barbell2':'Barbell',
 'strap':'Ankle Strap',
 'rowing':'Rowing Bench',
 'training':'Dumbbell training',
 'correction':'Posture correction',
 'exercise':"Aerobic exercise",
 'BarbellTraining':'Barbell training',
 'core2':'core',
 'Stretching':'Stretching',
 'cableMachine':"Cable Machine Exercises",
 "Boxing":"Boxing",
//  header
 'shopping':'SHOPPING',
 'aboutUs':'ABOUT US',
 'order':'My Order',
 'logout':'Log Out',
 'login':'Log In',
 'register':'Register',
//  footer
 'news':'Get the latest news',
 'contactUs':'Contact Us',
 'address':'Room 1003, Building 3,Sunmax Techonology Park,No. 8 Keyuan Road, Yuehai Subdistrict,Nanshan District, Shenzhen, China',
 'rights':'Copyright © 2021 Speediance.All rights reserved.',
 'Speediance':'Speediance',
 'faq':'FAQ',
 'policy':'Privacy Policy',
 'service':'Warranty&Returns',
 'blog':'Blog',
 'affiliate':'Affiliate Program',
 'dealer':'Become a Speediance Dealer',
 'ABOUT':'ABOUT',
 'SUPPORT':'SUPPORT',
 'PRODUCT':'PRODUCT',
 'App':'Speediance App',
 'AboutUs':'About Us',
 'Shopping':'Shopping',
//  shopping
 'package':'Which Speediance Package is right for you?',
 'pick':'Pick the perfect package to transform your home into a complete home gym.',
 'Shop':'Shop Package',
 'includes':'includes',
 'off':'OFF',
 'Accessories':'Accessories',
 'additional':'Here you can choose the additional accessories you need',
 'toCart':'Add to Cart',
//  confirm
 'back':'Back to All Packages',
 'notIncludes':'Not Includes delivery',
 'orderNow':'Order now at the best price',
 'ADDTOCART':'ADD TO CART',
//  cart
'YourCart':'Your Cart',
'QTY':'QTY',
'Remove':'Remove',
'empty':'Your shopping bag is empty',
'checkout':'checkout',
'shipping':'Different countries have different shipping rates',
// address
'contactInfo':'CONTACT INFO',
'delivery':'DELIVERY',
'payment':'PAYMENT',
'shippingAddress':"What's your shipping address?",
'multipleAddress':"If you'd like to ship your Speediance to multiple addresses, you'll need to check out separately for each shipping address.",
'emailAddress':'This email address will also be used for you to receive notifications and create an account in the future',
'Return':'Return',
'continue':'CONTINUE TO PAYMENT',
'review':'Review your order',
'SHIPPINGTO':'SHIPPING TO',
'purchase':'By completing my purchase, I confirm that I have read and agree to',
'PrivacyPolicy':'Privacy Policy',
'form':'I understand that my form of payment will be charged when I place the order.',
'agree':'You must first agree to the terms',
'card':'Pay now with credit card',
'PayPal':'Pay now with PayPal',
'protected':'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.',
'YOURCART':'YOUR CART',
'Subtotal':'Subtotal',
'Delivery':'Est. Delivery',
'SalesTax':'Sales Tax',
'Free':'free',
'promoCode':'Promo Code',
'Apply':'Apply',
'total':'Estimated Total',
'savings':'Total Order Savings',
'validZipCode':'please enter a valid Zip Code',
// agent
'way':"Let's make the world a more energetic place In the SMART way",
'SUBMIT':'SUBMIT',
'Successfully':'Submitted Successfully',
'backTo':'Back to Speediance',
'validEmail':'please enter a valid email',
'validNumber':'please enter a valid phone number',
// blog
'toBlog':' Back to Blog',
// forgetPwd
'sent':'A email has been sent to ',
'inbox':'Check your inbox for instructions on how to reset your password',
'toLogin':'Back to Log in',
'forgetPwd':'Forget password',
'Continue':'Continue',
'NewTo':'New to Speediance',
'signUp':'Sign up now.',
// login
'LOGIN':'LOG IN',
// my order
'orderNumber':'Order number',
'orderTime':'Order creation time',
'Total':'Total',
'payNow':'Pay now',
'detail':'Detail',
// register
'enterEmail':'Enter your email',
'8characters':'Must be at least 8 characters.',
'CONTINUE':'CONTINUE',
'notMatch':'Passwords do not match',
// shareAsale
'Affiliate':'Speediance Affiliate Program',
'join':'JOIN SHAREASALE',
// success
'Congratulations':'Congratulations',
'accepted':'Your order has been accepted',
'toShop':'Back to SHOPPING',
'registration':'Check the order after registration',
// td
'Unsubscribe':'Unsubscribe Successful',
'unsubscribe':'Unsubscribe',
'receiving':'To stop receiving General info and News from Speediance at',
'selectUnsubscribe':'please select Unsubscribe',
// verifyEmail
'verifyEmail':'Verify your Email',
'sentTo':'A verification email has been sent to',
'link':'Check your inbox and follow the link to activate your SPEEDIANCE account',
'RESEND':'RESEND',
// comfirmEmail
'Welcome':'Welcome to Speediance',
'learn':'LEARN MORE ABOUT SPEEDIANCE',
'notVerified':'Your email address could not be verified',
'verified':'Your email has been verified',
// resetPwd
'reset':'Your password has been reset successfully.',
'change':'Change Password',
'newPassword':'Enter a new password for',
'samePassword':'Please enter the same password',
// downloadApp
'SPEEDIANCEAPP':'SPEEDIANCE APP',
'goals':'Discover more ways to reach your goals',
'enjoy':'Enjoy Speediance classes from your phone.',
'SmartGym':"Speediance is the All-In-One Smart Home Gym and personal trainer. Unlike traditional dumbbells, barbells, and exercise equipment Speediance uses advanced digital weight that continually adapts workouts so they're most effective for you-all led by our expert coaches.",
// subscribe
'CONGRATULATIONS':'CONGRATULATIONS',
'updates':'You have been added to out list and will send you promotions & updates',
'OK':'OK',
'Subscribe':'Subscribe',
'discounts':'Sign up for exclusive deals and discounts',
'valid':'Please enter a valid email address',
'SUBSCRIBE':'SUBSCRIBE',
// about us
'pledged':'pledged',
'on':'on',
'Personal':'Personal All-In-One Home Gym & Workout Coach',
'gym':'Achieve full-body strength-training with an AI-powered personal gym that takes up only 3.2 ft² of space in your home',
'who':'Who are Speediance',
'Founded':'Founded in July 2020, Speediance is a young Chinese startup.',
'units':'With multiple patented technologies in motor units, smart digital technologies and intuitive design,Speediance aims to support everyone to achieve fitness in a safer, easier and more intellectual way.',
'lifestyle':"We believe that everyone is worthy of a healthy lifestyle, and the price threshold for an intellectual training experience should be reduced as much as possible. We're still on our way, but we shall never quit.",
'believe':'What we believe',
'energetic':'Our mission: To make the world a more energetic place.',
'happier':'We believe in technology and innovation with true purpose, and it is our dream to make people live healthier and happier. ',
'design':"With multiple patented technologies in motor unit, smart digital technologies and intuitive design, we aim to create a way for people to get fit at home without going to the gym or investing in expensive and redundant exercise gear. Instead,people can start strength training in a simple and effective way at home whenever they choose.",
'dreams':'The products are vessels for beliefs, dreams and love for life itself.',
'passion':'Empowering with passion',
'History':'History',
'beginning':'At the very beginning, what Speediance got was just this retrofitted hub motor solution and three youngsters who want to use the power of technology to help everyone keep fit and healthy in a more efficient and scientific way. With just that motor and their dream, they visited hundreds of investors. And now Speediance is on its way to the world.',
'members':'Team Members',
'industry':'After getting sponsored by an investor with the same vision in April 2021, Speediance started gathering fitness, hardware, and software experts with years of experience in the industry.  ',
'health':'From a team of three, Speediance has now become an energetic family of over 30 members from HKU, Wuhan University of Technology, University of Electronic Science and Technology of China, Alibaba, Huawei, Amazon and Baidu. Every one of us is looking forward to providing more solution and choice for those who value their own health.',
'first':'Users first',
'real':'Keep it real',
'curious':'Stay curious',
'haul':'Always for the long haul',
'Jul':'Jul. 2020',
'prototype':'Speediance was founded with only three members and one motor prototype',
'Oct':'Oct. 2020',
'prototype2':'Relocated from Chengdu to Shenzhen, created prototype 2.0',
'Jan':'Jan. 2021',
'prototype3':'Created prototype 3.0',
'Mar':'Mar. 2021',
'angel':'Received $2 millions of angel finance from Wave Front Ventures',
'Apr':'Apr. 2021',
'dozens':'Team expanded from ten to dozens',
'Jul2':'Jul. 2021',
'prototype4':'Created prototype 4.5',
'Sept':'Sept. 2021',
'brands':'Selected as one of the TOP 100 new brands in Tencent Neo-Star Project',
'Oct2':'Oct.  2021',
'Prototype5':'Prototype 5.0 was ready',
'Nov':'Nov. 2021',
'Kickstarter':'Launched on Kickstarter, raising $100,000 in 10 hours and US $400,000 in 14 days, In just one month, the campaign eventually raised $560,000',
'Liu Tao':'Liu Tao',
'ceo':'Founder/CEO',
'Manager':'Former Product Manager of FITURE and GIMI',
'Baidu':'Former Hardware PM of the only strategic oversea project of Baidu in 2018',
'Japan':'One of the products in his charge amended the record in crowdfunding history of Japan by 1 billion (JY)',
'Technology':'Graduated from Wuhan University of Technology',
'Yu Jian':'Yu Jian',
'CTO':'Co-founder/CTO',
'BaiduManager':'Former Tech manager of Baidu, in charge of Baidu Browser in oversea markets with over 10 million MAU',
'engineer':'Former engineer of Alibaba and Huawei',
'Founder':'Founder of his own company with average annual revenue of over 10 million (CNY)',
'HongkongUniversity':"Master's degree from Hongkong University",
'Huang Jiuming':'Huang Jiuming',
'Director':'Director of R&D',
'Former':'Former front-end manager of Baidu International',
'University':"Master's degree from University of Science and Technology of China",
'Gao Shifan':'Gao Shifan',
'Algorithm':'Algorithm Engineer',
'Robocon':'Second Price Winner of Chinese National Robocon, 2016',
'Science':'University of Electronic Science and Technology of China',
// 2022-1-11新增
// h5
'method':'Payment method',
'details':'Order details',
'summary':'Order summary',
'nextStep':'Calculated at next step',
'USD':'USD',
'MOQ':'Flexible MOQ(non-exclusive)',
'technical':'Online technical training',
'AfterSale':'After-sale Service Center',
'learnMore':'Learn more about working with Speediance',
'ASAP':'Register your interest and we will get back to you ASAP',
'noOrder':'No order yet',
'PACKAGE':'PACKAGE',
'ACCESSORIES':'ACCESSORIES',
'gotIt':'GOT IT',
// 订单状态
'Pending':'Pending',
'beShipped':'To be shipped',
'Shipped':'Shipped',
'Completed':'Completed',
'Closed':'Closed',
// 代理表单输入提示语
'newPwd':'your new password',
'Password':'Password',
'confirmNewPwd':'confirm your new password',
'confirmPwd':'Confirm Password',
'firstName':'First Name',
'Country':'Country/Region',
'phoneNumber':'Phone Number',
'Company':'Company',
'Title':'Title',
'Website':'Website',
'LinkedIn':'Linked-In',
'tellUs':'Tell us more',
// 地址表单输入提示语
'Address':'Address',
'Apartment':'Apartment,suite,etc.(optional)',
'city':'City/Town',
'state':'Province/State/Region',
'postalCode':'Zip Code/Postal Code',

'language':'Language',
'buyNow':'Buy Now',
'Shipping Policy':'Shipping Policy',
'Membership':'Membership',
'miniPro':'Login to Speediance mini-program and get one immediately!',
'Estimated delivery in Q2 2022':'Estimated delivery in Q2 2022'
}



// WEBPACK FOOTER //
// ./src/lang/en.js